import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class CryptographyDataService {
	private basePath: string = `${environment.url}/api/Cryptography/`;

	constructor(private http: HttpClient) {}

	getAsymmetricPublicKey() {
		return this.http.get(`${this.basePath}GetAsymmetricPublicKey`, {
			responseType: "text",
		  });
	}
}
